export enum KEY_CODES {
  UP    = 38,
  DOWN  = 40,
  ENTER = 13,
  SPACE = 32
}
